import { Box, Container, Typography, styled } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { PublicRoutes } from '@/config/routes';

const FooterWrapper = styled(Box)(({ theme }) => ({
  padding: '32px 0',
  backgroundColor: '#FFFFFF',
  borderTop: '1px solid #F5F5F5',
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: '32px 0 0',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '16px',
  },
}));

const FooterLinks = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '24px',
}));

const PolicyLink = styled(Link)({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 500,
  color: '#717680',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
    color: '#9D1500',
  },
});

const FooterSection: React.FC<{ isFixdDomain: boolean }> = ({ isFixdDomain }) => (
  <FooterWrapper>
    <Container maxWidth="lg">
      <FooterContent>
        <FooterLinks>
          <PolicyLink to={PublicRoutes.termsOfService}>Terms & Conditions</PolicyLink>
          <PolicyLink to={PublicRoutes.privacyPolicy}>Privacy Policy</PolicyLink>
        </FooterLinks>
        <Typography
          variant="body2"
          sx={{
            color: '#717680',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          © {new Date().getFullYear()} {isFixdDomain ? 'Fixd.ai' : 'Terr.ai'}. All rights reserved.
        </Typography>
      </FooterContent>
    </Container>
  </FooterWrapper>
);

export default FooterSection;
